import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useAlert, types } from 'react-alert';
import { saveAs } from 'file-saver';
import { parse } from 'date-fns';
import { LinkText, SecondaryButton, RateWithNumber, ButtonWithIcon, ScrollArea } from '../../../components';
import * as Constants from '../../../common/constants';
import { useJobUser, useMaster, useChat } from '../../../../model/hooks';
import { DateHelper } from '../../../../common/helper';
export const UserInfoCard = memo((props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const { userId, applyId, jobOfferId, jobOffer } = props;
    const { t } = useTranslation();
    const history = useHistory();
    const reactAlert = useAlert();
    const { loadJobUser, loadSubmitDocuments, loadReviewRatingAve, loadReviewList, loadJobHistoriesList, loadingJobUser, loadingReview, loadingJobHistory, } = useJobUser();
    const { master } = useMaster();
    const { loadMyRoomIdByWorkerId } = useChat();
    const [jobUser, setJobUser] = useState(null);
    const [reviewAve, setReviewAve] = useState(0);
    const [review, setReview] = useState([]);
    const [jobHistories, setJobHistories] = useState([]);
    const [submitFromWorker, setSubmitFromWorker] = useState(null);
    // やりとり一覧へのリンク用
    const [myRoomId, setMyRoomId] = useState(null);
    // レビュー一覧取得
    const loadReviewListData = async (lastDocument) => {
        const result = await loadReviewList(userId, lastDocument);
        return result.data.map((item) => {
            var _a, _b, _c;
            return {
                jobOfferId: item.jobOfferId,
                clinicName: (_a = item.clinicName, (_a !== null && _a !== void 0 ? _a : '')),
                rating: (_b = item.rating, (_b !== null && _b !== void 0 ? _b : 0)),
                text: (_c = item.text, (_c !== null && _c !== void 0 ? _c : '')),
                detail: item,
            };
        });
    };
    // 業務履歴一覧取得
    const loadJobHistoriesListData = async (lastDocument) => {
        const result = await loadJobHistoriesList(userId, lastDocument);
        return result.data.map((item) => {
            return {
                jobOfferId: item.jobOfferId,
                thumbnails: item.thumbnails,
                title: item.title,
                description: item.description,
                detail: item,
            };
        });
    };
    // ユーザープロフィール
    useEffect(() => {
        const getJobUser = async () => {
            try {
                const result = await loadJobUser(userId);
                if (result === undefined) {
                    reactAlert.show(t('ユーザーが見つかりません'), { type: types.ERROR });
                    return;
                }
                setJobUser(result);
                const myRoomId = await loadMyRoomIdByWorkerId(jobOffer.clinicId, userId);
                setMyRoomId(myRoomId);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        getJobUser();
    }, [userId]);
    // 提出書類を取得
    useEffect(() => {
        const getSubmitDocuments = async () => {
            try {
                const result = await loadSubmitDocuments(jobOffer, userId);
                if (result === undefined) {
                    return;
                }
                setSubmitFromWorker(result);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        getSubmitDocuments();
    }, [userId, jobOfferId, applyId, jobOffer]);
    // レビュー平均
    useEffect(() => {
        const getReviewAve = async () => {
            var _a, _b;
            try {
                const result = await loadReviewRatingAve(userId);
                const data = result.data;
                setReviewAve((_b = (_a = data) === null || _a === void 0 ? void 0 : _a.reviewRatingAve, (_b !== null && _b !== void 0 ? _b : 0)));
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        getReviewAve();
    }, [userId]);
    // レビュー
    useEffect(() => {
        const getReview = async () => {
            try {
                const result = await loadReviewListData();
                setReview(result);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        getReview();
    }, [userId]);
    // 業務履歴
    useEffect(() => {
        const getJobHistories = async () => {
            try {
                const result = await loadJobHistoriesListData();
                setJobHistories(result);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        getJobHistories();
    }, [userId]);
    // もっと見る(レビュー)
    const onClickMoreReviewList = async () => {
        if (review.length > 0) {
            const lastRow = review.slice(-1)[0];
            const _rows = await loadReviewListData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setReview(review.concat(_rows));
            }
        }
    };
    // もっと見る(業務履歴)
    const onClickMoreJobHistoriesList = async () => {
        if (jobHistories.length > 0) {
            const lastRow = jobHistories.slice(-1)[0];
            const _rows = await loadJobHistoriesListData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setJobHistories(jobHistories.concat(_rows));
            }
        }
    };
    const onClickSumittedDocument = (item) => {
        if (submitFromWorker === null || item.id === undefined) {
            return;
        }
        const getSubmittedDocuments = (id) => {
            var _a, _b, _c, _d, _e;
            if (id === 0) {
                return _a = submitFromWorker.submittedDocuments1, (_a !== null && _a !== void 0 ? _a : null);
            }
            else if (id === 1) {
                return _b = submitFromWorker.submittedDocuments2, (_b !== null && _b !== void 0 ? _b : null);
            }
            else if (id === 2) {
                return _c = submitFromWorker.submittedDocuments3, (_c !== null && _c !== void 0 ? _c : null);
            }
            else if (id === 3) {
                return _d = submitFromWorker.submittedDocuments4, (_d !== null && _d !== void 0 ? _d : null);
            }
            else if (id === 4) {
                return _e = submitFromWorker.submittedDocuments5, (_e !== null && _e !== void 0 ? _e : null);
            }
            return null;
        };
        const documents = getSubmittedDocuments(item.id);
        if (documents === null || documents.length === 0) {
            reactAlert.show(t('ファイルが登録されていません'), { type: types.INFO });
            return;
        }
        documents.forEach((obj) => {
            obj.url && saveAs(obj.url, item.text);
        });
    };
    const onClickChatRoom = () => history.push(`/home/chat_list/${myRoomId}`);
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, sm: 6, style: { paddingBottom: '24px' } }, loadingJobUser ? (React.createElement(CircularProgress, { size: 30 })) : (React.createElement(React.Fragment, null,
                React.createElement(SRow, { style: { paddingBottom: '24px' } },
                    React.createElement(Avatar, { src: (_c = (_b = (_a = jobUser) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.url, (_c !== null && _c !== void 0 ? _c : '')), alt: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u753B\u50CF", style: { width: '60px', height: '60px' } }),
                    React.createElement(SUserName, null, `${(_d = jobUser) === null || _d === void 0 ? void 0 : _d.lastName} ${(_e = jobUser) === null || _e === void 0 ? void 0 : _e.firstName}`)),
                React.createElement(SUserDetail, null,
                    t('性別'),
                    "\uFF1A", (_h = (_g = (_f = master) === null || _f === void 0 ? void 0 : _f.genderList) === null || _g === void 0 ? void 0 : _g.find((obj) => { var _a; return obj.id === ((_a = jobUser) === null || _a === void 0 ? void 0 : _a.genderId); })) === null || _h === void 0 ? void 0 :
                    _h.text),
                React.createElement(SUserDetail, null,
                    t('生年月日'),
                    "\uFF1A",
                    ((_j = jobUser) === null || _j === void 0 ? void 0 : _j.birthday) && DateHelper.toStringDateOnly(parse((_k = jobUser) === null || _k === void 0 ? void 0 : _k.birthday, 'yyyyMMdd', new Date()))),
                React.createElement(SUserDetail, null,
                    t('メールアドレス'),
                    "\uFF1A", (_l = jobUser) === null || _l === void 0 ? void 0 :
                    _l.email),
                React.createElement(SUserDetail, null,
                    t('住所'),
                    "\uFF1A", (_m = jobUser) === null || _m === void 0 ? void 0 :
                    _m.locationAddress),
                React.createElement(SUserDetail, null,
                    t('電話番号'),
                    "\uFF1A", (_o = jobUser) === null || _o === void 0 ? void 0 :
                    _o.tel),
                React.createElement(SUserDetail, null,
                    t('臨床経験年数'),
                    "\uFF1A", (_r = (_q = (_p = master) === null || _p === void 0 ? void 0 : _p.clinicalExperienceList) === null || _q === void 0 ? void 0 : _q.find((obj) => { var _a; return obj.id === ((_a = jobUser) === null || _a === void 0 ? void 0 : _a.clinicalExperienceYearsId); })) === null || _r === void 0 ? void 0 :
                    _r.text),
                React.createElement(SUserDetail, null,
                    t('最終職歴'),
                    "\uFF1A", (_s = jobUser) === null || _s === void 0 ? void 0 :
                    _s.lastWorkplace),
                React.createElement(SUserDetail, null,
                    t('現在の勤務先'),
                    "\uFF1A", (_t = jobUser) === null || _t === void 0 ? void 0 :
                    _t.currentWorkplace), (_u = jobOffer.submittedDocuments) === null || _u === void 0 ? void 0 :
                _u.map((item) => (React.createElement(SSpacer, { key: item.id, paddingTop: "16px" },
                    React.createElement(LinkText, { onClick: () => onClickSumittedDocument(item) }, item.text)))),
                React.createElement(SSpacer, { paddingTop: "24px" },
                    React.createElement(SecondaryButton, { disabled: !myRoomId, onClick: onClickChatRoom }, t('やりとり一覧')))))),
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(SSubTitle, null, t('レビュー')),
                React.createElement(RateWithNumber, { value: reviewAve, size: "medium" }),
                React.createElement(ScrollArea, { height: "260px" },
                    review.map((obj) => {
                        var _a;
                        return (React.createElement("div", { key: obj.jobOfferId },
                            React.createElement(SRowReview, { style: { marginTop: '6px' } },
                                React.createElement(SClinicName, null, obj.clinicName),
                                React.createElement(RateWithNumber, { value: (_a = obj.rating, (_a !== null && _a !== void 0 ? _a : 0)), size: "small" })),
                            React.createElement(SContent, null, obj.text)));
                    }),
                    React.createElement("div", { style: { textAlign: 'center' } },
                        React.createElement(ButtonWithIcon, { text: "\u3082\u3063\u3068\u898B\u308B", iconName: "expand_more", iconPosition: "end", loading: loadingReview, onClick: onClickMoreReviewList }))),
                React.createElement(SDivider, null),
                React.createElement(SSubTitle, null, t('業務履歴')),
                React.createElement(ScrollArea, { height: "260px" },
                    jobHistories.map((obj) => {
                        var _a;
                        return (React.createElement("div", { key: obj.jobOfferId },
                            React.createElement(SRow, { style: { marginTop: '6px' } },
                                React.createElement(Avatar, { src: ((_a = obj) === null || _a === void 0 ? void 0 : _a.thumbnails) && `${obj.thumbnails[0].url}`, alt: "\u30AF\u30EA\u30CB\u30C3\u30AF\u753B\u50CF", style: { width: '30px', height: '30px' } }),
                                React.createElement(SJobName, null, obj.title)),
                            React.createElement(SContent, null, obj.description)));
                    }),
                    React.createElement("div", { style: { textAlign: 'center' } },
                        React.createElement(ButtonWithIcon, { text: "\u3082\u3063\u3068\u898B\u308B", iconName: "expand_more", iconPosition: "end", loading: loadingJobHistory, onClick: onClickMoreJobHistoriesList })))))));
});
const SRow = styled.div `
  display: flex;
  align-items: center;
`;
const SRowReview = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const SUserName = styled.p `
  margin-left: 24px;
  margin-bottom: 0;
  color: ${Constants.COLOR.ORANGE700};
  font-weight: bold;
`;
const SClinicName = styled.p `
  color: ${Constants.COLOR.ORANGE700};
  font-weight: bold;
  font-size: 14px;
  margin: 6px 0 0 0;
`;
const SJobName = styled.p `
  color: ${Constants.COLOR.ORANGE700};
  font-weight: bold;
  font-size: 14px;
  margin: 0 0 0 8px;
`;
const SUserDetail = styled.p `
  font-weight: bold;
`;
const SSpacer = styled.div `
  padding-top: ${({ paddingTop }) => paddingTop};
`;
const SSubTitle = styled.p `
  font-size: 20px;
  font-weight: bold;
  margin: 0;
`;
const SContent = styled.p `
  font-size: 13px;
  margin-top: 6px;
  margin-bottom: 0;
`;
const SDivider = styled(Divider) `
  &&& {
    margin-top: 6px;
    margin-bottom: 12px;
  }
`;
